import { ListingEffects } from './effects/listing.effects';
import { ListingService } from './services/listing.service';
import { ViewJobInfoPageComponent } from './containers/view-job-info-page.component';
import { ViewJobPageComponent } from './containers/view-job-page.component';
import { ViewPostJobPageComponent } from './containers/view-post-job-page.component';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { JobsEffects } from './effects/jobs.effects';
import { JobsService } from './services/job.service';
import { ComponentsModule } from './components';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../lib/services';
import { reducers } from './reducers';
import { SharedModule } from '../shared-module/shared.module';
import { CommonModule } from '@angular/common';
import { SelectedJobPageComponent } from './containers/selected-job-page.component';
import { ViewJobListingPageComponent } from './containers/view-job-listing-page.component';
import { JobListingModule } from '../job-listing-module/job-listing.module';
import { EditJobTplJobProcessComponent } from './edit-job-tpl-process/edit-job-tpl-job-process.component';
import { JobProcessModule } from './edit-job-tpl-process/job-process.module';
import { JobSourcingPageComponent } from '../job-sourcing-module/containers/job-sourcing-page.component';
import { JobSourcingModule } from '../job-sourcing-module/job-sourcing.module';
import { JobPostCanDeactivateGuard } from '../lib/services/routeGuard';

const COMPONENTS = [
  ViewPostJobPageComponent,
  ViewJobPageComponent,
  ViewJobInfoPageComponent,
  ViewJobListingPageComponent,
  SelectedJobPageComponent,
];

@NgModule({
  declarations: [COMPONENTS],
  imports: [
    StoreModule.forFeature('jobs', reducers),
    EffectsModule.forFeature([JobsEffects, ListingEffects]),
    ComponentsModule,
    SharedModule,
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: ViewPostJobPageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'post',
        component: ViewPostJobPageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ':id',
        component: ViewJobPageComponent,
        canActivate: [AuthGuard],
        canDeactivate: [JobPostCanDeactivateGuard],
        children: [
          {
            path: '',
            redirectTo: 'info',
            pathMatch: 'full',
          },
          { path: 'info', component: ViewJobInfoPageComponent },
          {
            path: 'job-listing',
            component: ViewJobListingPageComponent,
          },
          {
            path: 'process',
            component: EditJobTplJobProcessComponent,
          },
          { path: 'sourcing', component: JobSourcingPageComponent },
        ],
      },
    ]),
    // TODO it needs rework (whole module)
    JobListingModule,
    JobProcessModule,
    JobSourcingModule,
  ],
  providers: [JobsService, ListingService, JobPostCanDeactivateGuard],
})
export class JobsModule {}
